<template>
  <div class="popup" v-cloak v-if="isShow" style="z-index:600;">
      <div class="content" id="editCloudNotic">
            <div class="title">
                {{$t('language.popup.note')}}
                 <div class="icon white-close dialog-close" @click="isShow=false"></div>
            </div>
            <div class="editCloudNotic-body">
                   <div class="editCloudNotic-info">
                        {{$t('language.popup.editCloudNoticPopup.tips')}}
                   </div>
                   <div class="editCloudNotic-bottom">
                        <button style="min-width:110Px;float:right;padding:0 20px;" @click.stop="rewriteDrive()"> {{$t('language.popup.editCloudNoticPopup.btnTxt')}}</button>
                   </div>
            </div>
      </div>
  <editCloudResotreDialog ref="editCloudResotreDialog" :cloudType=cloudName :cloudId=cloudId style="z-index:601;"></editCloudResotreDialog>
  <editFtpDialog ref="editFtpDialog" style="z-index:601;"></editFtpDialog>
  <editNasDialog ref="editNasDialog" style="z-index:601;"></editNasDialog>
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import addCloudUtils from "@/js/workspace/add_cloud_utils.js";
import editFtpDialog from '@/components/popup/add_cloud_popups/edit_ftp_popup';
import editNasDialog from '@/components/popup/add_cloud_popups/edit_nas_popup';
import editCloudResotreDialog from "@/components/popup/add_cloud_popups/edit_cloud_restore_popup";

export default {
    data:function(){
        return{
            isShow:false,
            cloudName:false,
            cloudId:false,
            cloudInfo: []
        }
    },
    components: {
        editCloudResotreDialog,
        editFtpDialog,
        editNasDialog,
    },
    methods: {
        init(driverId){
            //通过id查询缓存中对应的云盘信息
            let clouds = this.$store.getters.getUsersDrives;
            let cloud = clouds.filter(item => item.id==driverId);
            if(cloud.length>0){
                let info = cloud[0];
                this.cloudName = info.appName;
                this.cloudId = info.id;
                this.cloudInfo = info;
                this.isShow = true;
            }
        },
        //编辑云盘
        rewriteDrive() {
            this.$refs.editCloudResotreDialog.cloudName = this.cloudName;
            this.$refs.editCloudResotreDialog.cloudInfo = this.cloudInfo;
            this.$refs.editCloudResotreDialog.cloudIcon = this.cloudName;
            if (this.cloudInfo.appName == 'FTP') {
                this.$refs.editFtpDialog.ftpDialog = true;
                this.$refs.editFtpDialog.cloudInfo = this.cloudInfo;
                let ftpInfo = this.cloudInfo.driveInfo;
                addCloudUtils.openFtpInfo(ftpInfo, this);
            } else if (this.cloudInfo.appName == 'NAS') {
                let nasInfo = this.cloudInfo.driveInfo;
                addCloudUtils.openNasInfo(nasInfo, this);
            } else {
                this.$refs.editCloudResotreDialog.editCloudShow = true;
                this.$refs.editCloudResotreDialog.inputCloudNameValue = this.cloudInfo.name;
                this.$refs.editCloudResotreDialog.email = this.cloudInfo.driveInfo.email;
                this.$refs.editCloudResotreDialog.tipShow = false;
                this.$nextTick(function() {
                    addCloudUtils.getContainerHeight(this.$refs.editCloudResotreDialog);
                });
            }
        },
    },
    
}
</script>

<style>
#editCloudNotic{
    width: 560Px;
    height: 220Px;
}
.editCloudNotic-body{
    width: 100%;
    height: 180Px;
    padding: 20Px 10Px 10Px 10Px;
    box-sizing: border-box;
    text-align: left;
  
}
.editCloudNotic-info{
    width: 100%;
    height:100Px;
    float: left;
}

.editCloudNotic-bottom{
    width: 528Px;
    height: 40Px;
    float: left;

}
.notraverseTimecheck-small {
    width: 15px;
    /*no*/
    height: 15px;
    /*no*/
    background-position: -20px -208px;
    /*no*/
}

.check-small {
    width: 15px;
    /*no*/
    height: 15px;
    /*no*/
    background-position: -88px -208px;
    /*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/popup/add_cloud_popups/edit_cloud_notic_popup.vue